import React from "react";
import { Switch, Route, match } from "react-router";
import { inject, observer } from "mobx-react";

import Main from "@src/Components/Pages/Main/Main";
import PrivateRoute from "@src/Components/hoc/PrivateRoute/PrivateRoute";
import { IValuesStore } from "Stores/Values/types";
import Authorization from "@src/Components/Pages/Authorization/Authorization";
import ComponentApps from "@src/Components/Common/ComponentApps/ComponentApps";
import Synchronization from "@src/Components/Pages/Synchronization/Synchronization";
import CompleteAccountLinkAuthorization from "@src/Components/Pages/CompleteAccountLinkAuthorization/CompleteAccountLinkAuthorization";
import PasswordReset from "@src/Components/Pages/PasswordReset/PasswordReset";
import PasswordCreate from "@src/Components/Pages/PasswordCreate/PasswordCreate";
import ForgotPassword from "@src/Components/Pages/ForgotPassword/ForgotPassword";

interface IProps {
  match: match;
  values?: IValuesStore;
}

@inject("values")
@observer
class Routes extends React.Component<IProps> {
  render() {
    return (
      <Switch>
        <Route path={`${this.props.match.url}login`} component={Authorization} />
        <Route path={`${this.props.match.url}CompleteAccountLink`} component={CompleteAccountLinkAuthorization} />
        <Route path={`${this.props.match.url}Auth/Authorize`} component={Authorization} />
        <Route path={`${this.props.match.url}Auth/AuthorizeError`} component={Authorization} />
        <Route path={`${this.props.match.url}apps`} render={() => <ComponentApps />} />
        <Route path={`${this.props.match.url}synchronization`} component={Synchronization} />
        <Route path={`${this.props.match.url}password-reset`} component={PasswordReset} />
        <Route path={`${this.props.match.url}password-create`} component={PasswordCreate} />
        <Route path={`${this.props.match.url}forgot-password`} component={ForgotPassword} />
        <PrivateRoute path={`${this.props.match.url}`} component={Main} />
      </Switch>
    );
  }
}

export default Routes;
